import React, { Component, useState, useRef, useEffect } from "react";
import countryGroups from "../assets/country-groups.json";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import ProductCard from "./../component/ProductCard";
import ProductCardSkeleton from "./../component/ProductCardSkeleton";
import HeadingSkeleton from "./../component/HeadingSkeleton";
import $ from "jquery";
import { API_BASE_URL, IMAGE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { NotificationManager } from "react-notifications";

const productImg = require("./../assets/img/product1-min.png");
const productImg2 = require("./../assets/img/product2-min.png");
const wishlistImg = require("./../assets/img/wishlist-icon2.svg").default;
const cartImg = require("./../assets/img/cart-icon.svg").default;
const filterImg = require("./../assets/img/filter-icon.svg").default;
const icon1 = require("./../assets/img/icon1.svg").default;
const icon2 = require("./../assets/img/icon2.svg").default;
const icon3 = require("./../assets/img/icon3.svg").default;
const icon4 = require("./../assets/img/icon4.svg").default;
const prevIcon = require("./../assets/img/chev-left.svg").default;
const nextIcon = require("./../assets/img/chev-right.svg").default;
const priceImg = require("./../assets/img/priceImg.svg").default;
const crossImg = require("./../assets/img/cross-icon.svg").default;

const Products = () => {
  // Filter states
  const [availableFilters, setAvailableFilters] = useState({ categories: [], product_categories: [], seasons: [], prices: [] });
  const [appliedFilters, setAppliedFilters] = useState({
    cat_id: [],
    product_categories: [],
    seasons: [],
    brand_countries: [],
    made_in_countries: [],
    prices: [],
    search_term: '',
    sort_key: 'default'
  });
  const [expandedGroups, setExpandedGroups] = useState({ categories: true, product_categories: true, seasons: true, prices: true, brand_countries: true, made_in_countries: true });
  const [expandedBrandGroups, setExpandedBrandGroups] = useState({ brand_countries: true });
  const [expandedMadeInGroups, setExpandedMadeInGroups] = useState({ made_in_countries: true });
  const [searchProductType, setSearchProductType] = useState('');
  const { user } = useAuth();
  const { selectedLanguage, langJson } = useLanguage();
  const { slugName } = useParams();

  const [isWebView, setIsWebView] = useState(window.innerWidth > 1299);
  const [showFilters, setShowFilters] = useState(window.innerWidth > 1299);
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState("default");
  const [sortKey, setSortKey] = useState("default");
  const [allDetails, setAllDetails] = useState();
  const [wishBtn, setWishBtn] = useState(false);
  const [openModal, setOpenModal] = useState();
  const [loading, setLoading] = useState(true);
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  const handleSort = (selectedSortKey) => {
    setSortKey(selectedSortKey);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}frontend/products`, {
        method: "POST",
        body: JSON.stringify({
          ...appliedFilters,
          category: slugName,
          sort_key: sortKey,
          lang: selectedLanguage,
          user_id: user?.id,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      setProducts(data.data.products);
      setAllDetails(data.data);
      setAvailableFilters(data.data.available_filters);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddWishlist = async (productId) => {
    if (!user) {
      $(".loginLink").click(() => {
        $(".loginPopup").addClass("active");
      });
      setOpenModal(!openModal);
      return null;
    } else {
      setWishBtn(true);
      try {
        const response = await fetch(`${API_BASE_URL}frontend/wishlists`, {
          method: "POST",
          body: JSON.stringify({
            product_id: productId,
            lang: selectedLanguage,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.authorisation?.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          NotificationManager.success(responseData.msg);
          setWishBtn(false);
          return responseData?.data?.wishlist?.id || null;
        } else {
          NotificationManager.warning(responseData.msg);
          setWishBtn(false);
          return null;
        }
      } catch (error) {
        console.error("Error during Sign UP:", error);
        setWishBtn(false);
        return null;
      }
    }
  };

  const handleRemoveWishlist = async wishlistId => {
    if (!wishlistId) return false;

    try {
      const response = await fetch(`${API_BASE_URL}frontend/wishlists/${wishlistId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${user?.authorisation?.token}`,
        },
      });

      const responseData = await response.json();
      if (!responseData?.res) {
        NotificationManager.warning(responseData?.msg);
        return false;
      }

      return true;
    } catch (error) {
      console.error("Remove wishlist error:", error);
      return false;
    }
  };

  const addWishlistAndUpdate = async productId => {
    const wishlistId = await handleAddWishlist(productId);
    if (!wishlistId) return;

    setProducts(prevProducts =>
      (prevProducts || []).map(product =>
        product.product_id === productId || product.colors?.some(color => color.product_id === productId)
          ? { ...product, wishlist_id: wishlistId }
          : product
      )
    );
  };

  const removeWishlistAndUpdate = async wishlistId => {
    const ok = await handleRemoveWishlist(wishlistId);
    if (!ok) return;

    setProducts(prevProducts =>
      (prevProducts || []).map(product =>
        Number(product?.wishlist_id) === Number(wishlistId) ? { ...product, wishlist_id: null } : product
      )
    );
  };

  useEffect(() => {
    fetchData();
    $(".dropDiv").each(function () {
      $("h3", this).click(() => {
        $(".subSidebar").hide();
        $(this).find(".subSidebar").toggle();
      });
    });
  }, [category, sortKey, slugName]);

  // Automatically fetch data when filters change
  useEffect(() => {
    fetchData();
  }, [appliedFilters]);

  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth > 1299;
      setIsWebView(desktop);

      if (desktop) {
        setMobileFilterOpen(false);
        setShowFilters(true);
      } else {
        setShowFilters(false);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <Header openModal={openModal} />
      <style>{`body { background: #FFF; }`}</style>

      <div className="fullContainer">
        <div className="featureDiv productListMain topNew tradePrdts" style={{ backgroundColor: "#FFF" }}>
          <div className="hdnSec topNew">
            {loading ? (
              <HeadingSkeleton width="250px" height="32px" />
            ) : (
              <h2 className="storeTabHdn">{langJson?.[allDetails?.category_slug] ?? allDetails?.category} </h2>
            )}
          </div>
          <div style={{ float: "left", display: "flex", gap: "20px", width: "100%" }}>

            {/* Sidebar Mount Logic updated for seamless mobile visibility */}
            {(isWebView ? showFilters : mobileFilterOpen) && (
              <>
                {!isWebView && (
                  <div
                    className="filterOverlay"
                    onClick={() => setMobileFilterOpen(false)}
                    style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', zIndex: 999 }}
                  />
                )}

                <div
                  className={`filterSidebar ${!isWebView
                      ? mobileFilterOpen
                        ? "mobile-open"
                        : "mobile-close"
                      : ""
                    }`}
                  style={!isWebView ? { position: 'fixed', top: 0, left: 0, height: '100%', zIndex: 1000, background: '#fff', width: '300px', overflowY: 'auto' } : {}}
                >
                  {!isWebView && (
                    <div className="filterSidebarHeader" style={{ display: 'flex', justifyContent: 'space-between', padding: '15px', alignItems: 'center' }}>
                      <div className="filterGroupHeader">Filters</div>
                      <button
                        type="button"
                        className="closeFilterBtn"
                        onClick={() => setMobileFilterOpen(false)}
                        style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }}
                      >
                        ✕
                      </button>
                    </div>
                  )}

                  {/* Categories Filter */}
                  {availableFilters.categories.length > 1 && (
                    <div className="filterGroup" style={{ padding: '0 15px' }}>
                      <div className="filterGroupHeader" onClick={() => setExpandedGroups(g => ({ ...g, categories: !g.categories }))}>
                        {langJson?.categories || "Categories"}
                      </div>
                      {expandedGroups.categories && availableFilters.categories && (
                        <ul>
                          {availableFilters.categories.map(cat => (
                            <li key={cat.id}>
                              <label className="filterOption">
                                <input
                                  type="checkbox"
                                  checked={appliedFilters.cat_id?.includes(cat.id)}
                                  onChange={() => {
                                    setAppliedFilters(f => {
                                      let updated;
                                      if (!f.cat_id.includes(cat.id)) {
                                        updated = [...f.cat_id, cat.id];
                                      } else {
                                        updated = f.cat_id.filter(id => id !== cat.id);
                                      }
                                      return { ...f, cat_id: updated };
                                    });
                                  }}
                                />
                                {langJson?.[cat.slug] ?? cat.title}
                              </label>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  )}

                  {/* Product Categories Filter */}
                  <div className="filterGroup" style={{ padding: '15px' }}>
                    <div className="filterGroupHeader" onClick={() => setExpandedGroups(g => ({ ...g, product_categories: !g.product_categories }))}>
                      {langJson?.producttype || "Product Type"}
                    </div>
                    {expandedGroups.product_categories && availableFilters.product_categories && (
                      <>
                        <input
                          className="filterSearch"
                          type="text"
                          placeholder={langJson?.search || "Search"}
                          value={searchProductType}
                          onChange={e => setSearchProductType(e.target.value)}
                          style={{ marginBottom: '8px', width: '100%' }}
                        />
                        <ul>
                          {availableFilters.product_categories
                            .filter(cat => (langJson?.[cat.slug] ?? cat.title).toLowerCase().includes(searchProductType.toLowerCase()))
                            .map(cat => (
                              <li key={cat.id}>
                                <label className="filterOption">
                                  <input
                                    type="checkbox"
                                    checked={appliedFilters.product_categories?.includes(cat.id)}
                                    onChange={() => {
                                      setAppliedFilters(f => {
                                        let updated;
                                        if (!f.product_categories.includes(cat.id)) {
                                          updated = [...f.product_categories, cat.id];
                                        } else {
                                          updated = f.product_categories.filter(id => id !== cat.id);
                                        }
                                        return { ...f, product_categories: updated };
                                      });
                                    }}
                                  />
                                  {langJson?.[cat.slug] ?? cat.title}
                                </label>
                              </li>
                            ))}
                        </ul>
                      </>
                    )}
                  </div>

                  <hr />

                  {/* Price Filter */}
                  <div className="filterGroup" style={{ padding: '15px' }}>
                    <div className="filterGroupHeader" onClick={() => setExpandedGroups(g => ({ ...g, prices: !g.prices }))}>
                      {langJson?.price || "Price"}
                    </div>
                    {expandedGroups.prices && (
                      <div style={{ marginTop: '8px' }}>
                        <ul>
                          {["0 – 10", "10 – 30", "30 – 50", "50 – 100", "100+"].map((label, idx) => (
                            <li key={label}>
                              <label className="filterOption">
                                <input
                                  type="checkbox"
                                  checked={appliedFilters.prices?.includes(idx)}
                                  onChange={e => {
                                    setAppliedFilters(f => {
                                      let updated;
                                      if (e.target.checked) {
                                        updated = [...(f.prices || []), idx];
                                      } else {
                                        updated = (f.prices || []).filter(i => i !== idx);
                                      }
                                      return { ...f, prices: updated };
                                    });
                                  }}
                                />
                                {label}
                              </label>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>

                  

                  {/* Brand Countries Filter */}
                  <div className="filterGroup" style={{ padding: '15px' ,  display: 'none' }}>
                    <div className="filterGroupHeader" onClick={() => setExpandedBrandGroups(g => ({ ...g, brand_countries: !g.brand_countries }))}>
                      {langJson?.brandlocation || "Brand location"}
                    </div>
                    {expandedBrandGroups.brand_countries && availableFilters.brand_countries && (
                      <div>
                        {countryGroups.map(group => (
                          <div key={group.group} style={{ marginBottom: '8px' }}>
                            <div
                              className="filterOption"
                              onClick={() => {
                                if (group.countries.length > 1) {
                                  setExpandedBrandGroups(g => ({ ...g, [group.group]: !g[group.group] }));
                                }
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={group.countries.every(country => appliedFilters.brand_countries.includes(country.code))}
                                indeterminate={group.countries.some(country => appliedFilters.brand_countries.includes(country.code)) && !group.countries.every(country => appliedFilters.brand_countries.includes(country.code))}
                                onChange={e => {
                                  const allCodes = group.countries.map(c => c.code);
                                  setAppliedFilters(f => {
                                    let updated;
                                    if (e.target.checked) {
                                      updated = Array.from(new Set([...f.brand_countries, ...allCodes]));
                                    } else {
                                      updated = f.brand_countries.filter(code => !allCodes.includes(code));
                                    }
                                    return { ...f, brand_countries: updated };
                                  });
                                }}
                              />
                              {group.group}
                            </div>
                            {(group.countries.length === 1 || expandedBrandGroups[group.group]) && (
                              <div style={{ marginLeft: 16, display: group.countries.length <= 1 ? 'none' : 'block' }}>
                                {group.countries.map(country => (
                                  <label className="filterOption" key={country.code}>
                                    <input
                                      type="checkbox"
                                      checked={appliedFilters.brand_countries.includes(country.code)}
                                      onChange={e => {
                                        setAppliedFilters(f => {
                                          let updated;
                                          if (e.target.checked) {
                                            updated = [...f.brand_countries, country.code];
                                          } else {
                                            updated = f.brand_countries.filter(code => code !== country.code);
                                          }
                                          return { ...f, brand_countries: updated };
                                        });
                                      }}
                                    />
                                    {country.names[selectedLanguage] || country.names["en"]}
                                  </label>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <hr />

                  {/* Made In Countries Filter */}
                  <div className="filterGroup" style={{ padding: '15px', display: 'none' }}>
                    <div className="filterGroupHeader" onClick={() => setExpandedMadeInGroups(g => ({ ...g, made_in_countries: !g.made_in_countries }))}>
                      {langJson?.madein || "Made In"}
                    </div>
                    {expandedMadeInGroups.made_in_countries && availableFilters.made_in_countries && (
                      <div>
                        {countryGroups.map(group => (
                          <div key={group.group} style={{ marginBottom: '8px' }}>
                            <div
                              className="filterOption"
                              onClick={() => {
                                if (group.countries.length > 1) {
                                  setExpandedMadeInGroups(g => ({ ...g, [group.group]: !g[group.group] }));
                                }
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={group.countries.every(country => appliedFilters.made_in_countries.includes(country.code))}
                                indeterminate={group.countries.some(country => appliedFilters.made_in_countries.includes(country.code)) && !group.countries.every(country => appliedFilters.made_in_countries.includes(country.code))}
                                onChange={e => {
                                  const allCodes = group.countries.map(c => c.code);
                                  setAppliedFilters(f => {
                                    let updated;
                                    if (e.target.checked) {
                                      updated = Array.from(new Set([...f.made_in_countries, ...allCodes]));
                                    } else {
                                      updated = f.made_in_countries.filter(code => !allCodes.includes(code));
                                    }
                                    return { ...f, made_in_countries: updated };
                                  });
                                }}
                              />
                              {group.group}
                            </div>
                            {(group.countries.length === 1 || expandedMadeInGroups[group.group]) && (
                              <div style={{ marginLeft: 16, display: group.countries.length <= 1 ? 'none' : 'block' }}>
                                {group.countries.map(country => (
                                  <label className="filterOption" key={country.code}>
                                    <input
                                      type="checkbox"
                                      checked={appliedFilters.made_in_countries.includes(country.code)}
                                      onChange={e => {
                                        setAppliedFilters(f => {
                                          let updated;
                                          if (e.target.checked) {
                                            updated = [...f.made_in_countries, country.code];
                                          } else {
                                            updated = f.made_in_countries.filter(code => code !== country.code);
                                          }
                                          return { ...f, made_in_countries: updated };
                                        });
                                      }}
                                    />
                                    {country.names[selectedLanguage] || country.names["en"]}
                                  </label>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}

            <div className="" style={{ flex: 1 }}>
              <div className="prdtFilter">
                <button
                  className={`filterToggleBtn ${(isWebView ? showFilters : mobileFilterOpen) ? "active" : ""}`}
                  onClick={() => {
                    if (isWebView) {
                      setShowFilters(!showFilters);
                    } else {
                      setMobileFilterOpen(!mobileFilterOpen); // Correctly toggles the mobile state open/close
                    }
                  }}
                >
                  <div className="fs-filter__icon">
                    {(isWebView ? showFilters : mobileFilterOpen) ?
                      <svg className="svgicon sc-86e4b53c-0 caTARJ fslegacy-icon svgicon-font-size" focusable="false" viewBox="0 0 12 7" aria-hidden="true" role="presentation" style={{ "--f-svg-color": "inherit", "--f-svg-fill": "none", "--f-svg-font-size": "16px" }}><path stroke="currentColor" d="M1 6.00005L6 0.994751L11 6.00005"></path></svg>
                      :
                      <svg className="svgicon fslegacy-icon svgicon-font-size" focusable="false" viewBox="0 0 12 12" aria-hidden="true" role="presentation" style={{ color: 'inherit', fill: 'none', fontSize: '16px' }}><path d="M9.30001 9.66659H12V10.3333H9.30001C9.14559 11.094 8.47299 11.6666 7.66667 11.6666C6.74619 11.6666 6 10.9204 6 9.99992C6 9.07944 6.74619 8.33325 7.66667 8.33325C8.47299 8.33325 9.14559 8.90584 9.30001 9.66659ZM5.30001 5.66659H12V6.33325H5.30001C5.14559 7.094 4.47299 7.66659 3.66667 7.66659C2.74619 7.66659 2 6.92039 2 5.99992C2 5.07944 2.74619 4.33325 3.66667 4.33325C4.47299 4.33325 5.14559 4.90584 5.30001 5.66659ZM10.6333 1.66659H12V2.33325H10.6333C10.4789 3.094 9.80632 3.66659 9 3.66659C8.07953 3.66659 7.33333 2.92039 7.33333 1.99992C7.33333 1.07944 8.07953 0.333252 9 0.333252C9.80632 0.333252 10.4789 0.905839 10.6333 1.66659ZM0 2.33325V1.66659H7.33333V2.33325H0ZM9 2.99992C9.55229 2.99992 10 2.5522 10 1.99992C10 1.44763 9.55229 0.999919 9 0.999919C8.44772 0.999919 8 1.44763 8 1.99992C8 2.5522 8.44772 2.99992 9 2.99992ZM0 6.33325V5.66659H2V6.33325H0ZM3.66667 6.99992C4.21895 6.99992 4.66667 6.5522 4.66667 5.99992C4.66667 5.44763 4.21895 4.99992 3.66667 4.99992C3.11438 4.99992 2.66667 5.44763 2.66667 5.99992C2.66667 6.5522 3.11438 6.99992 3.66667 6.99992ZM0 10.3333V9.66659H6V10.3333H0ZM7.66667 10.9999C8.21895 10.9999 8.66667 10.5522 8.66667 9.99992C8.66667 9.44763 8.21895 8.99992 7.66667 8.99992C7.11438 8.99992 6.66667 9.44763 6.66667 9.99992C6.66667 10.5522 7.11438 10.9999 7.66667 10.9999Z" fill="currentColor"></path></svg>
                    }
                  </div>
                  <span className="fs-filter__label">
                    {(isWebView ? showFilters : mobileFilterOpen) ? (langJson?.hidefilters || "Hide filters") : (langJson?.showfilters || "All")}
                  </span>
                </button>

                <button className={sortKey === "relevance" ? "active" : ""} onClick={() => handleSort("relevance")}>
                  {langJson?.relevance}
                </button>
                <button className={sortKey === "popularity" ? "active" : ""} onClick={() => handleSort("popularity")}>
                  {langJson?.popularity}
                </button>
                <button className={sortKey === "low_to_high" ? "active" : ""} onClick={() => handleSort("low_to_high")}>
                  {langJson?.pricelowtohigh}
                </button>
                <button className={sortKey === "high_to_low" ? "active" : ""} onClick={() => handleSort("high_to_low")}>
                  {langJson?.pricehightolow}
                </button>
                <button className={sortKey === "newest_first" ? "active" : ""} onClick={() => handleSort("newest_first")}>
                  {langJson?.newestfirst}
                </button>
              </div>

              <div className="productList">
                <ul className={`products responsiveSliderGrid ${isWebView ? (showFilters ? 'products-5-col' : 'products-6-col') : ''}`}>
                  {loading ? (
                    Array.from({ length: 12 }).map((_, index) => (
                      <ProductCardSkeleton key={index} />
                    ))
                  ) : products && products.length > 0 ? (
                    products.map((product, index) => (
                      <ProductCard
                        key={product.order_no}
                        product={product}
                        handleAddWishlist={addWishlistAndUpdate}
                        handleRemoveWishlist={removeWishlistAndUpdate}
                        showStore={true}
                        store={product?.store}
                      />
                    ))
                  ) : (
                    <div className="noItemFoundClass">{langJson?.noitemsfound}</div>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="provideDiv">
          <ul>
            <li>
              <img src={icon1} alt="" />
              <h3>{langJson?.easyreturn}</h3>
            </li>
            <li>
              <img src={icon2} alt="" />
              <h3>{langJson?.fastshipping}</h3>
            </li>
            <li>
              <img src={icon3} alt="" />
              <h3>{langJson?.securepayments}</h3>
            </li>
            <li>
              <img src={icon4} alt="" />
              <h3>{langJson?.friendlysupport}</h3>
            </li>
          </ul>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Products;